import axios from 'axios';


const proratedPreview = async (widget) => {
    // Load/refresh the widget script if URL/data changed    
    if (widget.firstLoad) {
        window.widgetJson = widget;
        const scriptId = widget.name;

        window.mjFrontend = process.env.REACT_APP_CLIENT_URL;
        window.mjServerUrl = process.env.REACT_APP_SERVER_URL;

        // First load the CSS
        const styleElement = document.createElement('link');
        styleElement.href = window.mjFrontend + '/styles/widget/prorated.css';
        styleElement.rel = "stylesheet";
        styleElement.type = "text/css";
        styleElement.id = 'mjwi-style-prorated';
        document.head.appendChild(styleElement);

        const existingScript = document.getElementById('mjwi-script-' + scriptId);
        if (existingScript) {
            existingScript.parentNode.removeChild(existingScript);
        }

        const scriptElement = document.createElement('script');
        scriptElement.src = process.env.REACT_APP_CLIENT_URL + '/scripts/widget/' + scriptId + '.js';
        try {
            const response = await axios.head(scriptElement.src, { timeout: 5000 });
            if(response.status === 200){
                scriptElement.type = 'text/javascript';
                scriptElement.id = 'mjwi-script-' + scriptId;
                document.head.appendChild(scriptElement);
            }
        } 
        catch {
            console.log('Main file does not exist');
        }
    } else {
        const htmldata = widget.htmlData.prorated;
        const generalData = htmldata.general;
        const headingData = htmldata.heading;
        const fieldData = htmldata.field;
        const buttonData = htmldata.button;
        const resultData = htmldata.result;

        const headingEl = document.querySelector('.heading');
        const fieldEl = document.querySelectorAll('#label');
        const buttonEl = document.querySelector('#calculateRent');
        const resultEl = document.querySelector('#resultSection');
        const containerEl = document.querySelector('.prorated-container');

        if (headingEl) {            
            headingEl.style.color = headingData.headingColor;
            headingEl.innerHTML = headingData.proratedHeading;
            containerEl.style.backgroundColor = generalData.containerBg;
            headingEl.style.fontFamily = headingData.headingFontFamily;
            headingEl.style.fontSize = headingData.headingFontSize + 'px';
            headingEl.style.fontWeight = headingData.headingFontBold === 'on' ? 'bold' : 'normal';
            headingEl.style.fontStyle = headingData.headingFontItalic === 'on' ? 'italic' : 'normal';
        }

        if (fieldEl) {
            fieldEl.forEach(field => {
                field.style.color = fieldData.fieldColor;
                field.style.fontFamily = fieldData.fieldFontFamily;
                field.style.fontSize = fieldData.fieldFontSize + 'px';
            });
        }

        if (buttonEl) {
            // Apply base button styles
            buttonEl.style.fontFamily = buttonData.buttonFontFamily;
            buttonEl.style.fontSize = buttonData.buttonFontSize + 'px';
            buttonEl.style.color = buttonData.buttonColor;
            buttonEl.style.background = buttonData.buttonBg;
            buttonEl.style.boxShadow = `0 5px 15px ${buttonData.buttonBoxShadow}4D`;
            
            // Remove any existing hover style element
            const existingHoverStyle = document.getElementById('button-hover-style');
            if (existingHoverStyle) {
                existingHoverStyle.parentNode.removeChild(existingHoverStyle);
            }
            
            // Create new style element with all button styles including hover
            const styleElement = document.createElement('style');
            styleElement.id = 'button-hover-style';
            styleElement.textContent = `
                #calculateRent {
                    color: ${buttonData.buttonColor} !important;
                    background: ${buttonData.buttonBg} !important;
                    box-shadow: 0 5px 15px ${buttonData.buttonBoxShadow}4D !important;
                    transition: all 0.3s ease;
                }
                #calculateRent:hover {
                    color: ${buttonData.buttonHoverText} !important;
                    background: ${buttonData.buttonHoverBg} !important;
                    box-shadow: 0 5px 15px ${buttonData.buttonHover}80 !important;
                }
            `;
            document.head.appendChild(styleElement);
        }

        if (resultEl) {
            resultEl.style.color = resultData.resultColor;
            resultEl.style.backgroundColor = resultData.resultBg;
            resultEl.style.borderLeft = `4px solid ${resultData.resultBorder}`;
            containerEl.classList.remove('vertical');
            containerEl.classList.remove('horizontal');
            containerEl.classList.add(resultData.resultLayout);
        }
    }
};

export default proratedPreview;